export const ACCESSIBILITY_MODAL = {
    HIDE_FOR_SCREEN_READERS_LABEL: {
      key: 'HIDE_FOR_SCREEN_READERS_LABEL',
      value: 'Hide for Screen readers'
    },
    ACCESSIBILITY_TOOLTIP: {
      key: 'ACCESSIBILITY_TOOLTIP',
      value: 'Accessibility'
    },
    SUMMARY_SCREEN_READER_LABEL: {
      key: 'SUMMARY_SCREEN_READER_LABEL',
      value: 'Provide a summary for screen readers:'
    },
  };